import { Component, computed, inject, input, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { StateService } from '../../services/state.service';
import { KpiRecentInstitutionComponent } from '../../visuals/kpi-recent-institution/kpi-recent-institution.component';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-peer-comparison-multi',
  standalone: true,
  imports: [RouterModule, KpiRecentInstitutionComponent],
  templateUrl: './peer-comparison-multi.component.html',
  styleUrl: './peer-comparison-multi.component.scss'
})
export class PeerComparisonMultiComponent {
  private router = inject(Router);
  private stateService = inject(StateService);
  readonly institution = inject(StateService).institution;

  readonly hasPeerComparison = input.required<boolean>();
  readonly hasNonMaturity = input.required<boolean>();
  readonly hasBothProducts = input.required<boolean>();
  readonly hasNoProducts = input.required<boolean>();
  readonly isBank = input<boolean>(false);

  protected readonly productState = computed(() => ({
    hasPeerComparison: this.hasPeerComparison(),
    hasNonMaturity: this.hasNonMaturity(),
    hasBothProducts: this.hasBothProducts(),
    isBank: this.isBank()
  }));


  protected readonly title = computed(() => {
    const state = this.productState();
    if (state.isBank) return "Non-Maturity Deposits"
    if (state.hasBothProducts && !state.isBank) return "Peer Comparison + Non-Maturity Deposits";
    if (state.hasNonMaturity) return "Non-Maturity Deposits";
    if (state.hasPeerComparison) return "Peer Comparison";
    return "Dashboard";
  });


  protected readonly gotoProductLink = computed(() => {
    const state = this.productState();
    if (state.hasBothProducts) return "/non-maturity-deposits";
    if (state.hasNonMaturity) return "/non-maturity-deposits";
    if (state.hasPeerComparison) return "/peer-comparison";
    return "/non-maturity-deposits";
  });


  readonly sortedInstitutions = computed(() => {
    const institutions = this.stateService.userInstitutions().slice();
    return institutions.sort((a, b) => ((a.dateLastViewed ?? 0) < (b.dateLastViewed ?? 0)) ? 1 : -1).slice(0, 5);
  })

  onClick(iid: number) {
    if (this.hasNoProducts()) {
      Swal.fire({
        title: 'No Subscription',
        text: 'Organization does not have a current subscription to Peer Comparison.',
        confirmButtonText: 'Ok',
        confirmButtonColor: '#5f5f5f',
      });
    } else {
      if (this.productState().hasPeerComparison && !this.productState().isBank) {
        const institution = this.sortedInstitutions()?.find(i => i.iid == iid);
        if (institution) {
          this.stateService.setInstitution(institution);
          this.stateService.updateUserInstitutionLastViewed(institution);
          this.router.navigate(['/peer-comparison/balance/snapshot']);
        }
      }
      else if (this.productState().hasNonMaturity && this.productState().isBank) {
        this.router.navigate(['/non-maturity-deposits/decay_basic']);

      }
    }
  }
  
  navigate(path: string) {
    if (!this.hasNoProducts()) {
      this.router.navigate([path]);
    }
    else {
      Swal.fire({
        title: 'No Subscription',
        text: 'Organization does not have a current subscription to Peer Comparison.',
        confirmButtonText: 'Ok',
        confirmButtonColor: '#5f5f5f',
      });
    }
  }
}
